import axios from 'axios';

export default async function removeFunctions(
  accessToken,
  profileId,
  function_ids,
) {
  const requestOptions = {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  };

  try {
    const { data } = await axios.post(
      `${process.env.REACT_APP_PROFILES_API_URL}/remove/functions/${profileId}`,
      { function_ids },
      requestOptions,
    );

    console.log(data);
    return data;
  } catch (err) {
    console.log(err);
    return err;
  }
}
